import React from "react";
import { Link } from "react-router-dom";

const links = [
  { label: "Solutions", to: "/solutions" },
  { label: "Industries", to: "/industries" },
  { label: "OEM Manufacturing", to: "/oem-manufacturing" },
  { label: "Porcelain Tiles", to: "/porcelain-tiles" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#07111f] text-slate-300">
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Link to="/" className="inline-flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center rounded bg-[#b8894d] text-sm font-semibold text-white">DS</span>
              <span className="text-lg font-semibold tracking-wide text-white">DS Global Machines</span>
            </Link>
            <p className="mt-5 max-w-xl text-sm leading-7 text-slate-400">
              A U.S.-based international engineering, manufacturing, and sourcing partner for industrial machinery, OEM production, fabrication, building materials, and global procurement programs.
            </p>
          </div>
          <div>
            <h2 className="text-sm font-semibold uppercase tracking-[0.24em] text-white">Company</h2>
            <nav className="mt-5 grid gap-3 text-sm">
              {links.map((link) => (
                <Link key={link.to} to={link.to} className="hover:text-white">{link.label}</Link>
              ))}
            </nav>
          </div>
          <div>
            <h2 className="text-sm font-semibold uppercase tracking-[0.24em] text-white">Contact</h2>
            <div className="mt-5 space-y-3 text-sm text-slate-400">
              <p>Eagle Mountain, Utah, USA</p>
              <p>info@dsglobalmachines.com</p>
              <p>+1 (385) 461 4051</p>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6 text-xs text-slate-500">
          (c) 2026 DS Global Machines. International industrial sourcing and engineering coordination.
        </div>
      </div>
    </footer>
  );
}
